import React, { Component } from 'react';
import * as styled from './cell.styled';
import $ from 'jquery';
import bowser from 'bowser';
import magnify from '../../../static/img/interface/search-solid.svg';
import { store } from '../../../store';
import emptyPng from '../../../static/img/empty.png';

class Cell extends Component {

    constructor() {
        super();
        this.displayedOnce = false;
        this.cell = React.createRef();
        this.imgContainer = React.createRef();
        this.img = React.createRef();
        this.magnify = React.createRef();
        this.animationInit = 0;
        this.animationDone = false;
        this.isIE = bowser.getParser(window.navigator.userAgent).getBrowser().name === "Internet Explorer"
    }

    componentDidCatch(){}

    getAnimType() {
        return window.innerWidth > 900 && !this.isIE && !this.props.isMobileVersion ? this.props.data.type : 'fade-in';
    }

    setScrollerPercent(percent) {
        if (this.animationInit != window.innerHeight) {
            this.animationDone = false;
            this.animationInit = window.innerHeight;
        }
        switch(this.getAnimType()){
            case 'fade-in':
                if (percent >= -150 && percent <= 250) this.setAnimationTransform(percent)
                if (!this.animationDone && percent >= 0) {
                    $(this.cell.current)
                        .css('transition', 'opacity 2s')
                        .css('opacity', 1)
                        .css('transform', 'none');
                        this.animationDone = true;

                }
                break;
            case 'scroll-from-right':
            case 'scroll-from-left':
            case 'scroll-from-top':
            case 'scroll-from-bottom':
                if (percent >= -150 && percent <= 250) {
                    let rect = this.cell.current.getBoundingClientRect();
                    if ($(this.cell.current).css('opacity') == 0) {
                        $(this.cell.current)
                            .css('transition', 'none')
                            .css('opacity', 1);
                    }
                    this.setAnimationTransform(percent);
                } else {
                    $(this.cell.current)
                        .css('transition', 'none')
                        .css('opacity', 0);
                    this.setAnimationTransform();
                }
                break;
        }
    }

    setAnimationTransform(percent) {
        if (percent !== undefined) {
            if (!this.displayedOnce) {
                $(this.img.current).attr('src', `./img/photos/${this.props.data.images[0]}`);
                this.displayedOnce = true;
            }
        }
        switch(this.getAnimType()){
            case 'scroll-from-right':
                if (percent)
                    $(this.cell.current).css('transform', `translate(${window.innerWidth - (window.innerWidth * (percent / 100))}px`);
                else
                    $(this.cell.current).css('transform', 'translate(2000px, 0)');
                break;
            case 'scroll-from-left':
                if (percent)
                    $(this.cell.current).css('transform', `translate(${-window.innerWidth + (window.innerWidth * (percent / 100))}px`);
                else
                    $(this.cell.current).css('transform', 'translate(-2000px, 0)');
                break;
            case 'scroll-from-top':
                if (percent)
                    $(this.cell.current).css('transform', `translate(0, ${-(window.innerHeight * 3) + ((window.innerHeight * 3) * (percent / 100))}px)`);
                else
                    $(this.cell.current).css('transform', 'translate(0, -2000px)');
                break;
            case 'scroll-from-bottom':
                if (percent)
                    $(this.cell.current).css('transform', `translate(0, ${window.innerHeight - (window.innerHeight * (percent / 100))}px)`);
                else
                    $(this.cell.current).css('transform', 'translate(0, 2000px)');
                break;
        }
    }

    onMouseEnterImg() {
        $(this.img.current).css('opacity', 0.6);
        $(this.magnify.current).css('opacity', 1);
    }

    onMouseLeaveImg() {
        $(this.img.current).css('opacity', 1);
        $(this.magnify.current).css('opacity', 0);
    }

    openMagnify() {
        store.display.set({magnify: `./img/photos/${this.props.data.images[0]}`});
    }

    getCellStyle() {
        if (!this.isIE) {
            if (this.getAnimType() == 'fade-in') return null;

            let marginModifier = 1;
            let marginLeft = 0;
            let marginRight = 0;
            let screenRatio = window.innerHeight / window.innerWidth;
            if (screenRatio > 0.56) {
                marginModifier = 1 - ((screenRatio - 0.56) * 1.8);
            }
            if (this.props.data.left) marginLeft = this.applyModifier(this.props.data.left, marginModifier);
            if (this.props.data.right) marginRight = this.applyModifier(this.props.data.right, marginModifier);

            let style = {
                height: `${this.props.height}px`,
                marginLeft,
                marginRight,
                justifyContent: this.props.data.justify
            };
            return style;
        } else {
            return {
                width: `${100 / this.props.totalCells}%`,
                display: 'block',
                textAlign: 'center'
            };
        }
    }

    applyModifier(value, modifier) {
        if (value == 'auto') return value;
        let unit = value.substring(value.length - 2, value.length)
        return (parseFloat(value) * modifier) + unit;
    }

    render() {
        return (
            <styled.Cell
                ref={this.cell}
                animType={this.getAnimType()}
                align={this.props.data.align}
                height={this.props.data.height}
                left={this.props.data.left}
                style={this.getCellStyle()}
                className={this.props.isMobileVersion ? 'mobileVersion' : null}
                
            >
                <styled.ImgContainer ref={this.imgContainer} onClick={this.openMagnify.bind(this)}>
                    <styled.Img
                        ref={this.img}
                        src={`./${emptyPng}`}
                        alt={this.props.data.images[0]}
                        className={this.props.isMobileVersion ? 'mobileVersion' : null}
                        onMouseEnter={this.onMouseEnterImg.bind(this)}
                        onMouseLeave={this.onMouseLeaveImg.bind(this)}
                        onMouseMove={this.onMouseEnterImg.bind(this)}
                    />
                </styled.ImgContainer>
                {!this.isIE ?
                    <styled.Magnify ref={this.magnify} className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                        <img src={`./${magnify}`} alt="magnify" className={this.props.isMobileVersion ? 'mobileVersion' : null} />
                    </styled.Magnify>
                    : 
                    null
                }
            </styled.Cell>
        );
    }
}

export default Cell;